import styled from '@emotion/styled';
import {observer} from 'mobx-react-lite';
import React from 'react';

type Props = {
  children?: React.ReactNode;
} & React.TableHTMLAttributes<HTMLTableRowElement>;

const UFieldRow = ({children, ...props}: Props): React.ReactElement => (
  <Row {...props}>{children}</Row>
);

export const FieldRow = observer(UFieldRow);

const Row = styled.tr`
  display: grid;
  grid-template-columns: auto 1fr auto;
  grid-template-rows: repeat(2, auto);
  grid-template-areas: 'prefix header postfix' 'prefix value postfix';

  :not(:last-of-type) {
    margin-bottom: var(--gutter-little);
  }
`;
